/**
 * Gold-Pakete für Echtgeld-Käufe.
 * `priceId` ist die Paddle-`external_id` (siehe `payments--batch_create_product`).
 * Diese Datei ist die einzige Quelle der Wahrheit für Server (Webhook) und Client (UI).
 */

export type GoldPackId =
  | "gold_pack_starter"
  | "gold_pack_small"
  | "gold_pack_medium"
  | "gold_pack_large"
  | "gold_pack_epic"
  | "gold_pack_legendary";

export interface GoldPack {
  id: GoldPackId;
  priceId: string;
  gold: number;
  priceCents: number;
  currency: "EUR";
  label: string;
  /** Bonus in Prozent vs. Starter-Paket (1 €/1000 Gold). 0 = Basis. */
  bonusPct: number;
  highlight?: "popular" | "best-value";
}

export const GOLD_PACKS: ReadonlyArray<GoldPack> = [
  {
    id: "gold_pack_starter",
    priceId: "gold_pack_starter_price",
    gold: 1_000,
    priceCents: 100,
    currency: "EUR",
    label: "Starter",
    bonusPct: 0,
  },
  {
    id: "gold_pack_small",
    priceId: "gold_pack_small_price",
    gold: 6_500,
    priceCents: 500,
    currency: "EUR",
    label: "Klein",
    bonusPct: 30,
  },
  {
    id: "gold_pack_medium",
    priceId: "gold_pack_medium_price",
    gold: 15_000,
    priceCents: 1_000,
    currency: "EUR",
    label: "Mittel",
    bonusPct: 50,
    highlight: "popular",
  },
  {
    id: "gold_pack_large",
    priceId: "gold_pack_large_price",
    gold: 34_000,
    priceCents: 2_000,
    currency: "EUR",
    label: "Groß",
    bonusPct: 70,
  },
  {
    id: "gold_pack_epic",
    priceId: "gold_pack_epic_price",
    gold: 78_000,
    priceCents: 4_000,
    currency: "EUR",
    label: "Episch",
    bonusPct: 95,
  },
  {
    id: "gold_pack_legendary",
    priceId: "gold_pack_legendary_price",
    gold: 150_000,
    priceCents: 6_000,
    currency: "EUR",
    label: "Legendär",
    bonusPct: 150,
    highlight: "best-value",
  },
];

export function findGoldPackById(id: string): GoldPack | undefined {
  return GOLD_PACKS.find((p) => p.id === id);
}

export function findGoldPackByPriceId(priceId: string): GoldPack | undefined {
  return GOLD_PACKS.find((p) => p.priceId === priceId);
}

export function formatEuro(cents: number): string {
  return (cents / 100).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });
}

export function formatGold(amount: number): string {
  return amount.toLocaleString("de-DE");
}
